module.exports = __webpack_public_path__ + "static/media/remove-icon.553481db.svg";